import { LINKS, CONTENT } from "../../const/config";
import { AndroidIcon, AppleIcon, PlatformDownload } from "../../components/home/Index";
import Footer from "../../components/Footer";
import { useStoreLinks } from "../../hooks/useStoreLinks";

export default function MobileView({ device }) {
  const isAndroid = device === "android";
  const { links: storeLinks } = useStoreLinks();

  const platformData = isAndroid
    ? {
      icon: <AndroidIcon />,
      title: "Android",
      directLink: LINKS.android.direct,
      storeLink: storeLinks.android,
    }
    : {
      icon: <AppleIcon />,
      title: "iOS",
      directLink: LINKS.ios.direct,
      storeLink: storeLinks.ios,
    };

  return (
    <div className="min-h-screen bg-white flex flex-col" style={{ fontFamily: "'Montserrat', sans-serif" }}>

      {/* ─── Header bar ─── */}
      <header className="w-full pt-6 flex justify-center">
        <div className="text-center">
          <p className="text-gray-800 text-s font-bold">
            {CONTENT.header.title.split("-").map((item, index, arr) => (
              <span key={index}>
                {item.trim()}
                {index < arr.length - 1 && <br />}
              </span>
            ))}
          </p>
        </div>
      </header>

      <main className="flex-1 w-full max-w-lg mx-auto px-5 py-5 flex flex-col items-center gap-5">
        {/* ─── Download ─── */}
        <div className="w-full bg-gray-50 rounded-2xl p-4 flex flex-col items-center gap-3">
          <PlatformDownload {...platformData} compact />
        </div>
      </main>

      <Footer />
    </div>
  );
}
